import { Link } from "react-router-dom";

const stats = [
  { value: "10+", label: "品牌沉淀年份" },
  { value: "500+", label: "原创内容发布" },
  { value: "3", label: "核心内容频道" },
  { value: "46%", label: "可持续材质占比" },
];

export default function SiteIntro() {
  return (
    <section className="bg-background-50 px-4 py-14 md:px-8 md:py-20 lg:px-12">
      <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-2 lg:gap-16">
        <div className="order-2 lg:order-1">
          <p className="text-xs font-semibold uppercase tracking-[0.25em] text-accent-600">About Taipei Nana</p>
          <h2 className="mt-3 font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-3xl">
            用专业的内容，陪伴每一种生活方式
          </h2>
          <p className="mt-5 text-sm leading-relaxed text-foreground-600 md:text-base">
            台北娜娜创立于 2016 年，是一个聚焦时尚生活与潮流资讯的品牌。我们相信，品质感并不遥远，它就藏在一杯咖啡的温度、一件大衣的剪裁，以及每一个被认真对待的日常瞬间里。
          </p>
          <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
            官网汇集品牌动态、生活方式与潮流趋势三大频道，持续为用户提供丰富、专业且值得信赖的内容参考，也让品牌与热爱生活的人走得更近。
          </p>
          <div className="mt-8 flex flex-wrap gap-3">
            <Link
              to="/about"
              className="inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              了解品牌故事
              <i className="ri-arrow-right-line" />
            </Link>
            <Link
              to="/contact"
              className="inline-flex items-center gap-2 whitespace-nowrap rounded-full border border-background-300 px-6 py-3 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-600"
            >
              联系我们
            </Link>
          </div>
        </div>

        <div className="order-1 lg:order-2">
          <div className="overflow-hidden rounded-2xl border border-background-200">
            <div className="aspect-[4/3] w-full">
              <img
                src="https://readdy.ai/api/search-image?query=elegant%20minimal%20brand%20studio%20interior%20with%20warm%20natural%20light%2C%20neutral%20tones%2C%20garments%20on%20racks%20and%20soft%20textures%2C%20editorial%20photography&width=1200&height=900&seq=intro-brand-2026&orientation=landscape"
                alt="台北娜娜品牌空间"
                title="台北娜娜品牌理念 - 时尚生活与潮流资讯"
                className="h-full w-full object-cover object-top"
              />
            </div>
          </div>
          <div className="mt-5 grid grid-cols-2 gap-4 sm:grid-cols-4">
            {stats.map((stat) => (
              <div
                key={stat.label}
                className="rounded-xl border border-background-200 bg-background-100 px-4 py-4 text-center"
              >
                <p className="font-heading text-xl font-extrabold text-primary-600 md:text-2xl">{stat.value}</p>
                <p className="mt-1 text-xs text-foreground-500">{stat.label}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}